export default {
  PurchaseLabels: 'labelPurchasingType.PurchaseLabels',
  UseOwnLabels: 'labelPurchasingType.UseOwnLabels'
}

export const labelPurchasingEnum = {
  PurchaseLabels: 1,
  UseOwnLabels: 2
}

export const labelPurchasingApiEnum = {
  [labelPurchasingEnum.PurchaseLabels]: 2,
  [labelPurchasingEnum.UseOwnLabels]: 3
}
